import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { BitfApiService } from '@bitf/services/api/bitf-api.service';

import { IBitfApiRequest, IBitfApiResponse } from '@interfaces';
import { Child } from '@models';

export interface IResetPasswordResult {
  newPassword: string;
}

@Injectable({
  providedIn: 'root',
})
export class ChildrenService extends BitfApiService {
  constructor(protected injector: Injector) {
    super('children', injector);
  }

  getByBeaconAddress(address: string) {
    return super.action<Child>({
      action: '/get-by-beacon-address',
      actionParams: `address='${address}'`,
    } as IBitfApiRequest);
  }

  resetPassword(child: Child, newPassword: string | null = null): Observable<IBitfApiResponse<IResetPasswordResult>> {
    return this.request({
      id: child.id,
      path: '/reset-password',
      method: 'POST',
      isBodyRaw: true,
      body: { newPassword },
    });
  }
}
